import {
  PARAM_CLI_SUCCES,
  PARAM_CLI_ECHEC,
  PARAM_UPDATE_SUCCES,
  PARAM_UPDATE_ECHEC,
} from '../constantes/paramAppConstantes'

export const paramParCliReducer = (state = { params: [] }, action) => {
  switch (action.type) {
    case PARAM_CLI_SUCCES:
      return {
        params: action.payload,
      }
    case PARAM_CLI_ECHEC:
      return {
        erreur: action.payload,
      }

    default:
      return state
  }
}

export const updateParamReducer = (
  state = { param: {}, succes: false },
  action
) => {
  switch (action.type) {
    case PARAM_UPDATE_SUCCES:
      return {
        succes: true,
        param: action.payload,
      }
    case PARAM_UPDATE_ECHEC:
      return {
        erreur: action.payload,
        succes: false,
      }

    default:
      return state
  }
}
